<select (change)="onChange($event)">
  <option value=""></option>
  @for(option of options; track option.value) {
    <option [value]="option.value" [selected]="option.value === value">{{option.label}}</option>
  }
</select>
